import { render } from "./scheduleUserCard.vue?vue&type=template&id=2764c7d5&scoped=true"
import script from "./scheduleUserCard.vue?vue&type=script&lang=js"
export * from "./scheduleUserCard.vue?vue&type=script&lang=js"

import "./scheduleUserCard.vue?vue&type=style&index=0&id=2764c7d5&scoped=true&lang=scss"

import exportComponent from "D:\\wemet-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2764c7d5"]])

export default __exports__